module.exports = __webpack_public_path__ + "media/images/icons/twitter_black-4c482b4306ea28c9e6d6b87ece7c4f2e.svg";